import CourseAPI from "../api/course";


export const courses = {
    state: {
        courses: [],
        courseOptions:{
            lineCount:0,
            showDeleted:false,
            orderBy:'name',
            orderDirection:'asc',
            itemsPerPage:10,
            itemAdded:false,
            itemSearched:false,
            selectedYear:0
        },
        coursesLoadStatus: 0,
        coursesCopyStatus: 0,
        courseAddStatus: 0,
        courseAddText: "",

        courseEdit: {
            id: 0,
            lp: 0,
            name: '',
            year_id:0,
            department_id:'',
            room:'',
            from:'',
            to:'',
        },
        courseEditDefault: {
            id: 0,
            lp: 0,
            name: '',
            year_id:0,
            department_id:'',
            room:'',
            from:'',
            to:'',
        },
        courseEditLoadStatus: 0,
        courseEditStatus: 0,
        courseEditText: "",

        courseDeleteStatus: 0,
        courseDeleteText: "",

        //####################################
        course:{},
        courseLoadStatus: 0,

        //#####################################
        tempCourses: [],
        tempCoursesLoadStatus: 0,
        tempCourseAddStatus: 0,
        tempCourseAddText: "",
        tempCourseEdit: {
            id: 0,
            user_id: undefined,
            course_id:undefined,
            valid:[],
        },
        tempCourseEditDefault: {
            id: 0,
            user_id: undefined,
            course_id:undefined,
            valid:[],
        },
    },

    actions: {
        loadMyCourses({ state, commit, dispatch }) {
            commit("setCourses", []);
            commit("setCoursesLoadStatus", 1);
                CourseAPI.getMyCourses({
                    offset:0,
                    itemsPerPage:100, 
                    orderBy:state.courseOptions.orderBy,
                    orderDirection:state.courseOptions.orderDirection,
                    showDeleted:false,
                    selectedYear:state.courseOptions.selectedYear
                })
                .then(function(response) {
                    commit("setOptionsItemAddedAndSearchedFalse");
                    commit("setCourseLineCount", response.data.lineCount);
                    commit("setCourses", response.data.courses);
                    dispatch("applyIndexOnCourses");
                    commit("setCoursesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setCourses", []);
                    commit("setCoursesLoadStatus", 3);
                });
         
        },
        loadTempCourses({ state, commit, dispatch }) {
            commit("setTempCoursesLoadStatus", 1);
                CourseAPI.getTempCourses()
                .then(function(response) {
                    commit("setTempCourses", response.data);
                    dispatch("applyIndexOnTempCourses");
                    commit("setTempCoursesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setTempCourses", []);
                    commit("setTempCoursesLoadStatus", 3);
                });
         
        },
        addTempCourse({ commit, state, dispatch }, data) {
            commit("setTempCourseAddStatus", 1);
            commit("setTempCourseAddText", "");

            CourseAPI.postAddNewTempCourse(
                data.user_id,
                data.course_id,
                data.valid,
            )
                .then(function(response) {
                    commit("setTempCourseAddStatus", 2);
                    dispatch("loadLookups");
                    dispatch("loadTempCourses");
                    dispatch("applyIndexOnTempCourses");
                })
                .catch(function(error) {
                    commit("setTempCourseAddStatus", 3);
                    commit("setTempCourseAddText", error.response.data.errors);
                });
        },
        copyCourses({ commit, state, dispatch }, data) {
            commit("setCoursesCopyStatus", 1);

            CourseAPI.postCopyCourses(
                data.source,
                data.destination,
                data.users,
            )
                .then(function(response) {
                    commit("setCoursesCopyStatus", 2);
                    dispatch("loadCourses");
                })
                .catch(function(error) {
                    commit("setCoursesCopyStatus", 3);
                });
        },
        prolongTempCourse({ state, commit, dispatch },data) {
            commit("setTempCoursesLoadStatus", 1);
                CourseAPI.putProlongTempCourse(
                    data.slug,
                    data.duration
                )
                .then(function(response) {
                    dispatch("loadTempCourses");
                    dispatch("applyIndexOnTempCourses");
                    commit("setTempCoursesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setTempCourses", []);
                    commit("setTempCoursesLoadStatus", 3);
                });
         
        },
        applyIndexOnTempCourses({ commit, state, rootState }) {
            let localCourses = state.tempCourses;

            var i = 1;
            localCourses.forEach(course => {
                course.lp = i;
                i++;
            });

            commit("setTempCourses",localCourses);
        },
        loadCourses({ state, commit, dispatch }) {
            commit("setCoursesLoadStatus", 1);
                CourseAPI.getCourses({
                    offset:0,
                    itemsPerPage:state.courseOptions.itemsPerPage, 
                    orderBy:state.courseOptions.orderBy,
                    orderDirection:state.courseOptions.orderDirection,
                    showDeleted:state.courseOptions.showDeleted,
                    selectedYear:state.courseOptions.selectedYear
                })
                .then(function(response) {
                    commit("setOptionsItemAddedAndSearchedFalse");
                    commit("setCourseLineCount", response.data.lineCount);
                    commit("setCourses", response.data.courses);
                    dispatch("applyIndexOnCourses");
                    commit("setCoursesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setCourses", []);
                    commit("setCoursesLoadStatus", 3);
                });
         
        },
        loadMoreCourses({ state, commit, dispatch }) {
            commit("setCoursesLoadStatus", 1);
                CourseAPI.getCourses({
                    offset:state.courses.length,
                    itemsPerPage:state.courseOptions.itemsPerPage, 
                    orderBy:state.courseOptions.orderBy,
                    orderDirection:state.courseOptions.orderDirection,
                    showDeleted:state.courseOptions.showDeleted,
                    selectedYear:state.courseOptions.selectedYear
                })
                .then(function(response) {
                    commit("setCourseLineCount", response.data.lineCount);
                    commit("setCourses", _.concat(state.courses, response.data.courses));
                    dispatch("applyIndexOnCourses");
                    commit("setCoursesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setCourses", []);
                    commit("setCoursesLoadStatus", 3);
                });
         
        },
        searchCourses({ state, commit, dispatch },data) {
            commit("setCoursesLoadStatus", 1);
                CourseAPI.searchCourses({
                    showDeleted:state.courseOptions.showDeleted,
                    selectedYear:state.courseOptions.selectedYear,
                    filterableHeaders:data.filterableHeaders,
                    q:data.q
                })
                .then(function(response) {
                    commit("setOptionsItemAddedAndSearchedFalse");
                    commit("setCourseSearchedTrue");
                    commit("setCourseLineCount", response.data.lineCount);
                    commit("setCourses", response.data.courses);
                    dispatch("applyIndexOnCourses");
                    commit("setCoursesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setCourses", []);
                    commit("setCoursesLoadStatus", 3);
                });
         
        },
        setCourseOptions({ state, commit, dispatch },data){
            commit("setCourseOptions",data.options);
            dispatch("loadCourses");
        },
        applyIndexOnCourses({ commit, state, rootState }) {
            let localCourses = state.courses;

            var i = 1;
            localCourses.forEach(course => {
                if(_.isNumber(course.department_id)){
                    //course.department_id = _.find(rootState.lookups.departments, { 'value': course.department_id }).text;
                }
                // if(_.isArray(course.users)){
                //     course.users = _.map(course.users,u=>'<span class="'+ ((!u.status||u.pivot.temp)?'deleted':'') +'">'+u.name + ' ' + u.surname+'</span>').join(',')
                // }
            
                course.lp = i;
                i++;
            });

            commit("setCourses",localCourses);
        },
        addCourse({ commit, state, dispatch }, data) {
            commit("setCourseAddStatus", 1);
            commit("setCourseAddText", "");

            CourseAPI.postAddNewCourse(
                data.name,
                data.year_id,
                data.department_id,
                data.room,
                data.from,
                data.to,
            )
                .then(function(response) {
                    commit("setCourseAddStatus", 2);
                    commit("setAddedCourse",response.data);
                    commit("setCourseLineCount", state.courseOptions.lineCount + 1);
                    dispatch("applyIndexOnCourses");
                    dispatch("loadMenuDictionariesCount");
                    //dispatch("loadCourseLookup");
                })
                .catch(function(error) {
                    commit("setCourseAddStatus", 3);
                    commit("setCourseAddText", error.response.data.errors);
                });
        },

        loadCourseEdit({ commit }, data) {
            commit("setCourseEditLoadStatus", 1);
            commit("setCourseEditStatus", 0);
            commit("setCourseEditText", "");

            CourseAPI.getCourseEdit(data.slug)
                .then(function(response) {
                    commit("setCourseEdit", response.data);
                    commit("setCourseEditLoadStatus", 2);
                })
                .catch(function() {
                    commit("setCourseEdit", {});
                    commit("setCourseEditLoadStatus", 3);
                });
        },
        loadCourseEditDefault({ commit }) {
            commit("setCourseEditDefault");
        },
        loadTempCourseEditDefault({ commit }) {
            commit("setTempCourseEditDefault");
        },
        loadCourseAddDefault({ commit }) {
            commit("setCourseAddStatus", 0);
            commit("setCourseAddText", "");
        },
        loadTempCourseAddDefault({ commit }) {
            commit("setTempCourseAddStatus", 0);
            commit("setTempCourseAddText", "");
        },
        editCourse({ commit, state, dispatch }, data) {
            commit("setCourseEditStatus", 1);

            CourseAPI.putEditCourse(
                data.slug,
                data.name,
                data.year_id,
                data.department_id,
                data.room,
                data.from,
                data.to,
            )
                .then(function(response) {
           
                    commit("setCourseEditStatus", 2);
                    commit("setEditedCourse",response.data)
                    dispatch("applyIndexOnCourses");
                    dispatch("loadCourseLookup",{year_id:response.data.year_id});
                })
                .catch(function(error) {
                    commit("setCourseEditStatus", 3);
                    commit("setCourseEditText", error.response.data.errors);
                });
        },
        editCourseReactivate({ commit, state, dispatch }, data) {
            commit("setCourseEditStatus", 1);
  
            CourseAPI.putReactivateCourse(data.slug)
                .then(function(response) {
                    commit("setCourseEditStatus", 2);
                    commit("setEditedCourse",response.data)
                    dispatch("applyIndexOnCourses");
                    dispatch("loadMenuDictionariesCount");
                    //dispatch("loadCourseLookup");
                })
                .catch(function(error) {
                    commit("setCourseEditStatus", 3);
                });
        },
        deleteCourse({ commit, state, dispatch }, data) {
            commit("setCourseDeleteStatus", 1);

            CourseAPI.deleteCourse(data.slug)
                .then(function(response) {
                    commit("setCourseDeleteStatus", 2);
                    if(state.courseOptions.showDeleted){
                        commit("setEditedCourse",response.data)
                    }else{
                        commit("setCourseLineCount", state.courseOptions.lineCount - 1);
                        commit("setDeletedCourse",response.data)
                    }
                    dispatch("loadMenuDictionariesCount");
                    //dispatch("loadCourseLookup");
                    dispatch("applyIndexOnCourses");
                })
                .catch(function() {
                    commit("setCourseDeleteStatus", 3);
                });
        },
        forceDeleteCourse({ commit, state, dispatch }, data) {
            commit("setCourseDeleteStatus", 1);

            CourseAPI.forceDeleteCourse(data.slug)
                .then(function(response) {
                    commit("setCourseDeleteStatus", 2);
                    commit("setCourseLineCount", state.courseOptions.lineCount - 1);
                    commit("setDeletedCourse",response.data)
                    dispatch("applyIndexOnCourses");
                })
                .catch(function() {
                    commit("setCourseDeleteStatus", 3);
                });
        },
        //#############################################
        loadCourse({ commit, dispatch }, data) {
            commit("setCourseLoadStatus", 1);

            CourseAPI.getCourse(data.slug)
                .then(function(response) {
                    commit("setCourse", response.data);
                    dispatch("applyIndexOnCourse");
                    commit("setCourseLoadStatus", 2);
                })
                .catch(function() {
                    commit("setCourse", {});
                    commit("setCourseLoadStatus", 3);
                });
        },
        applyIndexOnCourse({ commit, state, rootState }) {
            let localCourse = state.course;
            
            var i = 1;
            localCourse.users.forEach(u => {
                u.lp = i;
                i++;
            });

            var i = 1;
            localCourse.children.forEach(u => {
                u.lp = i;
                i++;
            });

            commit("setCourse",localCourse);
        },
        addUserToCourse({ commit, state, dispatch }, data) {
            commit("setCourseEditStatus", 1);

            CourseAPI.putAddUser(data.slug,data.id)
                .then(function(response) {
                    commit("setCourseEditStatus", 2);
                    commit("setAddedUserCourse",response.data.users)
                    dispatch("applyIndexOnCourse");
                    ////dispatch("loadCourseLookup");
                })
                .catch(function(error) {
                    commit("setCourseEditStatus", 3);
                    commit("setCourseEditText", error.response.data.errors);
                });
        },
        addTempUserToCourse({ commit, state, dispatch }, data) {
            commit("setCourseEditStatus", 1);

            CourseAPI.putAddTempUser(data.slug,data.id)
                .then(function(response) {
                    commit("setCourseEditStatus", 2);
                    dispatch("loadMyCourses");
                    dispatch("loadLookups");
                })
                .catch(function(error) {
                    commit("setCourseEditStatus", 3);
                    commit("setCourseEditText", error.response.data.errors);
                });
        },
        deleteUserFromCourse({ commit, state, dispatch }, data) {
            commit("setCourseEditStatus", 1);

            CourseAPI.putDeleteUser(data.slug,data.id)
                .then(function(response) {
                    commit("setCourseEditStatus", 2);
                    commit("setDeletedUserCourse",response.data)
                    //dispatch("applyIndexOnCourse");
                    ////dispatch("loadCourseLookup");
                })
                .catch(function(error) {
                    commit("setCourseEditStatus", 3);
                    commit("setCourseEditText", error.response.data.errors);
                });
        },
        addChildrenToCourse({ commit, state, dispatch }, data) {
            commit("setCourseEditStatus", 1);

            CourseAPI.putAddChildren(data.slug,data.ids)
                .then(function(response) {
                    commit("setCourseEditStatus", 2);
                    dispatch("loadCourse",{slug:response.data.id});
                    dispatch("loadChildrenInCourse");
                    dispatch("applyIndexOnCourse");
                    ////dispatch("loadCourseLookup");
                })
                .catch(function(error) {
                    commit("setCourseEditStatus", 3);
                    commit("setCourseEditText", error.response.data.errors);
                });
        },

        deleteChildrenFromCourse({ commit, state, dispatch }, data) {
            commit("setCourseEditStatus", 1);

            CourseAPI.putDeleteChildren(data.slug,data.ids)
                .then(function(response) {
                    commit("setCourseEditStatus", 2);
                    dispatch("loadCourse",{slug:response.data.id});
                    dispatch("loadChildrenInCourse");
                    //commit("setDeletedChildrenCourse",response.data)
                    //dispatch("applyIndexOnCourse");
                    ////dispatch("loadCourseLookup");
                })
                .catch(function(error) {
                    commit("setCourseEditStatus", 3);
                    commit("setCourseEditText", error.response.data.errors);
                });
        },
    },
    mutations: {
        setCourseOptions(state,options){
            state.courseOptions = options;
            state.courseEdit.year_id = options.selectedYear;
            state.courseEditDefault.year_id = options.selectedYear;
        },
        setCoursesLoadStatus(state, status) {
            state.coursesLoadStatus = status;
        },
        setCoursesCopyStatus(state, status) {
            state.coursesCopyStatus = status;
        },
        setTempCoursesLoadStatus(state, status) {
            state.tempCoursesLoadStatus = status;
        },
        setCourses(state, courses) {
            state.courses = courses;
        },
        setTempCourses(state, courses) {
            state.tempCourses = courses;
        },
        setCourseLineCount(state, lineCount) {
            state.courseOptions.lineCount = lineCount;
        },
        setCourseAddStatus(state, status) {
            state.courseAddStatus = status;
        },
        setCourseAddText(state, text) {
            state.courseAddText = text;
        },
        setTempCourseAddStatus(state, status) {
            state.tempCourseAddStatus = status;
        },
        setTempCourseAddText(state, text) {
            state.tempCourseAddText = text;
        },
        setCourseEdit(state, course) {
            //pobiera dane do edycji
            state.courseEdit = course;
    
        },
        setEditedCourse(state, course) {
            var lp = _.find(state.courses,{'id':course.id}).lp;
            var index = _.findIndex(state.courses,{'id':course.id});
           
            state.courses[index] = course;
            state.courses[index].lp = lp;
        },
        setAddedCourse(state, course) {
           
            state.courseOptions.itemAdded = true;
            state.courses.push(course);
        },
        setCourseSearchedTrue(state) {
            state.courseOptions.itemSearched = true;
        },
        setOptionsItemAddedAndSearchedFalse(state) {
            state.courseOptions.itemAdded = false;
            state.courseOptions.itemSearched = false;
        },
        setDeletedCourse(state, course) {
            var index = _.findIndex(state.courses,{'id':course.id});
            state.courses.splice(index,1);
        },
        setCourseEditDefault(state) {
            state.courseEdit = { ...state.courseEditDefault };
        },
        setTempCourseEditDefault(state) {
            state.tempCourseEdit = { ...state.tempCourseEditDefault };
        },
        setCourseEditStatus(state, status) {
            state.courseEditStatus = status;
        },
        setCourseEditText(state, text) {
            state.courseEditText = text;
        },
        setCourseEditLoadStatus(state, status) {
            state.courseEditLoadStatus = status;
        },
        setCourseDeleteStatus(state, status) {
            state.courseDeleteStatus = status;
        },
        setCourseDeletedText(state, text) {
            state.courseDeleteText = text;
        },
        //#######################################
        setCourseLoadStatus(state, status) {
            state.courseLoadStatus = status;
        },
        setCourse(state, course) {
            state.course = course;
        },
        setAddedUserCourse(state, users) {
            //state.courseOptions.itemAdded = true;
            state.course.users = users;
        },
        setDeletedUserCourse(state, user) {
            var index = _.findIndex(state.course.users,{'id':user.id});
            state.course.users.splice(index,1);
        },
    },

    getters: {
        getCourseOptions(state){
            return state.courseOptions;
        },
        getCoursesLoadStatus(state) {
            return state.coursesLoadStatus;
        },
        getCoursesCopyStatus(state) {
            return function(){
                return state.coursesCopyStatus;
            }
        },
        getTempCoursesLoadStatus(state) {
            return state.tempCoursesLoadStatus;
        },
        getCourses(state) {
            return state.courses;
        },
        getTempCourses(state) {
            return state.tempCourses;
        },
        getCourseAddStatus(state) {
            return function(){
                return state.courseAddStatus;
            } 
        },
        getCourseAddText(state) {
            return state.courseAddText;
        },
        getTempCourseAddStatus(state) {
            return function(){
                return state.tempCourseAddStatus;
            } 
        },
        getTempCourseAddText(state) {
            return state.tempCourseAddText;
        },
        getCourseEdit(state) {
            return state.courseEdit;
        },
        getTempCourseEdit(state) {
            return state.tempCourseEdit;
        },
        getCourseEditStatus(state) {
          return function(){
            return state.courseEditStatus;
          }
        },
        getCourseEditing(state) {
            return state.courseEdit.id > 0;
        },
        getCourseEditText(state) {
            return state.courseEditText;
        },
        getCourseEditLoadStatus(state) {
            return state.courseEditLoadStatus;
            
        },
        getCourseDeleteStatus(state) {
            return function(){
                return state.courseDeleteStatus;
            }
        },
        getCourseDeleteText(state) {
            return state.courseDeleteText;
        },
        //######################################
        getCourseLoadStatus(state) {
            return state.courseLoadStatus;
        },
        getCourse(state) {
            return state.course;
        },
    }
};
